import { analyzeContextLinkClick, analyzeLogout } from '@client/analytics/redux/account/actions';
import { analyzeEvent } from '@client/analytics/redux/tealium/actions';
import { AccountInteractionAnalyticsBuilder } from '@client/analytics/utils/builders/AccountInteractionAnalyticsBuilder';
import { ContextLinkAnalyticsBuilder } from '@client/analytics/utils/builders/ContextLinkAnalyticsBuilder';
import { all, AllEffect, ForkEffect, put, PutEffect, takeLatest } from 'redux-saga/effects';

function* analyzeLogoutSaga(): Generator<PutEffect> {
  const builder = new AccountInteractionAnalyticsBuilder();

  yield put(analyzeEvent({
    ...builder.build(),
  }));
}

function* analyzeContextLinkClickSaga(
  action: ReturnType<typeof analyzeContextLinkClick>,
): Generator<PutEffect> {
  const { linkText, section, element } = action.payload;
  const builder = new ContextLinkAnalyticsBuilder(linkText, section, element);

  yield put(analyzeEvent({
    ...builder.build(),
  }));
}

export const accountAnalyticsSaga = function* (): Generator<AllEffect<ForkEffect>, void> {
  yield all([
    takeLatest(analyzeLogout.type, analyzeLogoutSaga),
    takeLatest(analyzeContextLinkClick.type, analyzeContextLinkClickSaga),
  ]);
};
